import { FC, CSSProperties } from 'react';
import { useTheme } from '@material-ui/core';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import { IconLabelBox } from '../../IconLabelBox';
import { useStyles } from './style';

interface Props {
  style?: CSSProperties;
  variant?: 'reduced' | 'default';
}

export const RunningIcon: FC<Props> = ({ style, variant }) => {
  const classes = useStyles();
  const theme = useTheme();

  return variant === 'reduced' ? (
    <AutorenewIcon
      className={`${classes.icon} ${classes.animatedIcon}`}
      style={style}
    />
  ) : (
    <IconLabelBox
      label="Running"
      backgroundColor={theme.palette.accent.light}
      icon={<AutorenewIcon style={style} htmlColor={theme.palette.black} />}
    />
  );
};
